export function createState() {
  return {
    toast: {
      message: '',
      variation: 'error',
    }
  }
}
